import {z} from 'zod/v4';

import {LocalizedString} from '../types/localized';

export const LocalizedStringSchema: z.ZodType<LocalizedString> = z.strictObject({
  fr: z.string(),
  en: z.string(),
});
